var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[(!_vm.hideName)?[_c('p',{staticClass:"mb-0"},[_c('b',[_vm._v(_vm._s(_vm.name || 'Date'))])])]:_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2rem"}},[_vm._v(_vm._s(_vm.formatDate(_vm.value, 'MMM YYYY')))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84927836","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/DateShow.vue
// module id = fRXm
// module chunks = 0 112